import {Component, computed, effect, inject, linkedSignal, output, signal, viewChild} from '@angular/core';
import {ButtonComponent, InputComponent, InputContainerComponent, ToastService} from "@components";
import {TranslocoDirective, TranslocoPipe} from "@jsverse/transloco";
import {IconDirective, PencilRuleIconComponent, PictureIconComponent} from "@icons";
import {AuthService} from "@api-services";
import {FormsModule, NgForm} from "@angular/forms";
import {SignupDto} from "@api-contracts";
import {catchError} from "rxjs/operators";
import {throwError} from "rxjs";
import {CheckboxComponent} from "@components";
import {CookieService} from "../../../components/cookie-policy-modal/cookie-policy-modal.component";

@Component({
  selector: 'wun-sign-in',
  imports: [
    TranslocoPipe,
    PencilRuleIconComponent,
    IconDirective,
    PictureIconComponent,
    InputComponent,
    InputContainerComponent,
    FormsModule,
    ButtonComponent,
    TranslocoDirective,
    CheckboxComponent
  ],
  templateUrl: './sign-in.component.html',
  styleUrl: './sign-in.component.scss'
})
export class SignInComponent {

  userSigned = output();
  private readonly toastService = inject(ToastService);
  private readonly cookieService = inject(CookieService);

  form = viewChild<NgForm>(NgForm)

  marked = signal(false)
  maxDate: string;

  get formValue(): (SignupDto & { confirmPassword: string }) | undefined {
    return this.form()?.value
  }

  private readonly authService = inject(AuthService);

  current = signal<SignupDto.ProfileTypeEnum>('ARTIST')

  constructor() {
    const today = new Date();
    const year = today.getFullYear() - 18;
    const month = String(today.getMonth() + 1).padStart(2, '0'); // mesi da 0 a 11
    const day = String(today.getDate()).padStart(2, '0');

    this.maxDate = `${year}-${month}-${day}`;
    effect(() => {
      this.form()?.valueChanges?.subscribe((value) => {
        const _ = this.form()?.value;
        if(_) {
          const checks = ['termsAndConditions', 'privacyPolicy', 'signDocument'].map(f => _[f])
          const valid = checks.every(f => f)
          this.marked.set(valid)
        }
      })
    });

  }

  signup() {
    this.form()!.form.markAllAsTouched();

    if (this.formValue?.password !== this.formValue?.confirmPassword) {
      this.toastService.addMessage({
        severity: 'error',
        title: 'signup.passwordNotMatch'
      })
      return;
    }


    if (!this.form()?.valid) {
      this.toastService.addMessage({
        severity: 'error',
        title: 'signup.fillAllInputs'
      })
      return;
    }

    if (!this.marked()) {
      this.toastService.addMessage({
        severity: 'error',
        title: 'signup.acceptConditions'
      })
      return;
    }


    if (!this.formValue) return;
    this.authService.authsSignup({
      signupDto: {
        ...this.formValue,
        phone: '-',
        username: this.formValue.email,
        profileType: this.current()
      },
    })
      .pipe(catchError((err) => {
        if (err.status === 409) {
          this.toastService.addMessage({
            severity: 'error',
            title: 'L\'email inserita è giá stata usata, se non ricordi la password segui la procedura di recupero'
          })
        }
        return throwError(() => err)
      }))
      .subscribe(d => {
        this.cookieService.signup(this.current());
        this.userSigned.emit();
      })
  }
}
